import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from "@reach/router"

export function Seo({
  title = "",
  description = "",
  pathname = "",
  image = "",
  author = "",
  publishDate = "",
  children = null,
  noFollow = false,
}) {
  const location = useLocation()
  const {
    site: { siteMetadata },
  } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteTitle
          siteTitleDefault
          siteUrl
          siteDescription
          siteImage
          twitter
          facebook
          instagram
          linkedin
        }
      }
    }
  `)

  const {
    siteTitle,
    siteTitleDefault,
    siteUrl,
    siteDescription,
    siteImage,
    twitter,
    facebook,
    instagram,
    linkedin,
  } = siteMetadata

  const seo = {
    title: title || siteTitleDefault,
    description: description || siteDescription,
    url: pathname ? `${siteUrl}${pathname}` : location.href,
    image: `${image ? image : siteUrl + siteImage}`,
    author: `${author}`,
    publishDate: `${publishDate}`,
  }

  // console.log("seo image", seo.image);
  // console.log("Publish Date",seo.publishDate);
  // console.log("author",seo.author);

  return (
    <>
      <title>{title ? `${title} | ${siteTitle}` : siteTitleDefault}</title>
      <meta name="theme-color" content="#000000" />
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:description" content={seo.description} />
      <meta property="linkedin:author" content={author} />
      <meta property="article:published_time" content={publishDate} />
      <meta property="og:image" content={seo.image} /> {/* Include the image URL */}
      <meta property="og:image:alt" content={siteTitle} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} /> {/* Include the image URL */}
      <meta name="twitter:creator" content={twitter} />
      {/* Facebook */}
      <meta property="article:author" content={`https://www.facebook.com/${facebook}`} /> {/* Facebook profile URL for the content creator */}

      {/* LinkedIn */}
      <meta property="linkedin:title" content={seo.title} />
      <meta property="linkedin:description" content={seo.description} />
      <meta property="linkedin:url" content={seo.url} />
      <meta property="linkedin:image" content={seo.image} />
      <meta property="linkedin:owner" content={`https://www.linkedin.com/in/${linkedin}`} /> {/* LinkedIn profile URL for the content creator */}


      {/* Instagram */}
      <meta property="insta:title" content={seo.title} />
      <meta property="insta:description" content={seo.description} />
      <meta property="insta:url" content={seo.url} />
      <meta property="insta:image" content={seo.image} />
      <meta property="insta:creator" content={`https://www.instagram.com/${instagram}`} /> {/* Instagram handle for the content creator */}
      {noFollow &&
        <meta name="robots" content="noindex, nofollow, noarchive, noimageindex, nosnippet"/>
      }

      <link rel="alternate" href={seo.url} hrefLang="en" />

      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
        hrefLang="en-SG"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon-16x16.png"
        hrefLang="en-SG"
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/apple-touch-icon.png"
        hrefLang="en-SG"
      />
      {/* The following meta tag is for demonstration only and can be removed */}
      {!!process.env.GATSBY_DEMO_STORE && (
        <meta
          name="robots"
          content="noindex, nofollow"
        />
      )}
      {children}
    </>
  )
}
